import * as Colors from 'material-ui/styles/colors';
import { LEFT_BAR_EXPANDED_WIDTH } from 'crazyEditor/components/EditorLeftBar/EditorLeftBarStyles';

export default {
  container: {
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    height: '100%',
    justifyContent: 'center',
    '@media (max-width: 1365px)': {
      justifyContent: 'flex-start',
    },
  },
  elementTypeContainer: {
    position: 'absolute',
    flexDirection: 'column',
    width: LEFT_BAR_EXPANDED_WIDTH,
    display: 'flex',
    left: 0,
    top: 0,
    alignItems: 'center',
    justifyContent: 'center',
    height: '118px',
    backgroundColor: Colors.grey200,
    fontSize: '16px',
    textTransform: 'uppercase',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 'normal',
    color: Colors.grey400,
    borderRight: `1px solid ${Colors.grey300}`,
    '@media (max-width: 1365px)': {
      position: 'relative',
    },
  },
  hyperlinkProperty: {
    display: 'none',
    '@media (min-width: 1250px)': {
      display: 'inline'
    }
  },
  elementTypeLabel: {
    paddingTop: '5px'
  },
  elementTypeArrow: {
    position: 'absolute',
    width: '15px',
    height: '15px',
    transform: 'rotate(-45deg)',
    left: '153px',
    top: '48px',
    background: Colors.grey50,
    boxShadow: `inset 1px 1px 0 0px ${Colors.grey300}`
  },
  menuContainer: {
    marginTop: 0,
    borderLeft: `1px solid ${Colors.grey300}`,
    userSelect: 'none',
    height: '118px',
    boxSizing: 'border-box',
    padding: '0 10px'
  },
  menuContainerFirst: {
    borderLeft: 0
  },
  menuTitle: {
    fontSize: '12px',
    textTransform: 'uppercase',
    fontFamily: 'Roboto, sans-serif',
    textAlign: 'center',
    color: Colors.grey400,
    padding: '10px 0'
  },
  menuBody: {
    height: 75,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    color: Colors.grey700,
    fontWeight: '400'
  }
};
